import { render, staticRenderFns } from "./BigVideo.vue?vue&type=template&id=9f81e594&scoped=true&"
import script from "./BigVideo.vue?vue&type=script&lang=js&"
export * from "./BigVideo.vue?vue&type=script&lang=js&"
import style0 from "./BigVideo.vue?vue&type=style&index=0&id=9f81e594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f81e594",
  null
  
)

component.options.__file = "BigVideo.vue"
export default component.exports